import {
  MOBILE_SCREEN_MAX_WIDTH,
  MOBILE_SCREEN_MIN_WIDTH,
} from '../../../constants/screen'

import { MULTI_VALUED_LIST_VISIBLE_COUNT_BY_SCREEN } from './MultiValuedList.constants'

export function multiValuesListMoreItemsSort(items) {
  return items
}

export function getMultiValuedListVisibleCountByScreen(screenWidth) {
  if (screenWidth <= MOBILE_SCREEN_MIN_WIDTH) {
    return MULTI_VALUED_LIST_VISIBLE_COUNT_BY_SCREEN.mobile
  }

  if (screenWidth <= MOBILE_SCREEN_MAX_WIDTH) {
    return MULTI_VALUED_LIST_VISIBLE_COUNT_BY_SCREEN.tablet
  }

  return MULTI_VALUED_LIST_VISIBLE_COUNT_BY_SCREEN.desktop
}
